// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error[data-v-fa1335d2]{display:block;margin-bottom:10px;color:#d0021b !important}", ""]);
// Exports
module.exports = exports;
